import React, { useState } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGetOutletsForCustomersQuery } from "../slices/OutletSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";
import {
  useGetOrdersQuery,
  useUpdateOrderStatusMutation,
} from "../slices/OrdersSlice";
import { useGetMyOutletFoodItemsQuery } from "../slices/FoodItemSilce";
import ReUsableModal from "../components/ReUsableModal";
import { toast } from "react-toastify";
import { getCurrentDate, getDateOfLast } from "../utils/getCurrentDate";

const OrdersScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { newOrders } = useSelector((state) => state.newOrders);
  const [orderId, setOrderId] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [deliveryOtp, setDeliveryOtp] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [orderQuantity, setOrderQuantity] = useState([]);
  const [itemQuantity, setItemQuantity] = useState([]);
  const [displayOrderId, setDisplayOrderId] = useState("");
  const [foodItemsApiQuery, setFoodItemsApiQuery] = useState(
    `currentlySelling=true&sort=itemQuantity`
  );
  const [apiQuery, setApiQuery] = useState(
    `createdAt[gte]=${new Date(
      new Date(getCurrentDate()).getTime() - 5.5 * 60 * 60 * 1000
    ).toISOString()}&sort=-createdAt`
  );
  const [showDelivered, setShowDelivered] = useState(false);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const navigate = useNavigate();
  const [showOutletOrders, setShowOutletOrders] = useState(false);
  const [searchText, setSearchText] = useState("");

  const {
    data: orders,
    isLoading,
    error,
    refetch: orderRefetch,
  } = useGetOrdersQuery({ query: apiQuery, token: userInfo?.token });
  const {
    data: foodItems,
    isLoading: isFoodItemsLoading,
    isError: foodItemsError,
    refetch: refetchFoodItems,
  } = useGetMyOutletFoodItemsQuery({
    query: foodItemsApiQuery,
    token: userInfo?.token,
  });

  const [ordersToList, setOrdersToList] = useState(orders);

  const [updateStatus, { isLoading: updateStatusLoading }] =
    useUpdateOrderStatusMutation();

  useEffect(() => {
    if (!ordersToList) return;

    const term = searchText.trim().toLowerCase();

    let updatedOrders = [];

    if (term) {
      if (term.length < 4) {
        // Match only orderId
        updatedOrders = ordersToList.filter((order) => {
          const orderIdStr = String(order?.orderId || "").toLowerCase();
          return orderIdStr.includes(term);
        });
      } else {
        // Match only mobileNumber
        updatedOrders = ordersToList.filter((order) => {
          const mobileNumberStr = String(
            order?.mobileNumber || ""
          ).toLowerCase();
          return mobileNumberStr.includes(term);
        });
      }
    } else {
      // If no search term, use filters
      if (showOutletOrders) {
        updatedOrders = ordersToList.filter(
          (order) => order.orderType === "outlet"
        );
      } else if (showDelivered) {
        updatedOrders = ordersToList.filter(
          (order) =>
            order.orderStatus === "Delivered" && order.orderType === "online"
        );
      } else {
        updatedOrders = ordersToList.filter(
          (order) =>
            order.orderStatus !== "Delivered" && order.orderType === "online"
        );
      }
    }

    setFilteredOrders(updatedOrders);
  }, [searchText, ordersToList, showDelivered, showOutletOrders]);

  const handleOrderStatusUpdate = async () => {
    try {
      const data = {
        _id: orderId,
        orderStatus: newStatus,
        deliveryOtp: deliveryOtp,
        token: userInfo.token,
      };
      await updateStatus(data).unwrap();
      toast.success("Status Updated Successfully");
      orderRefetch();
    } catch (e) {
      toast.error(e?.data?.error);
    }
  };

  const handleShowDelivered = () => {
    if (!ordersToList) return;
    const today = new Date();
    const deliveredToday = ordersToList?.filter(
      (order) =>
        order.orderStatus === "Delivered" && order.orderType === "online"
    );
    setFilteredOrders(deliveredToday);
    setShowDelivered(true);
    setShowOutletOrders(false);
  };

  useEffect(() => {
    orderRefetch();
    let orderDetails = {};
    const ors = isLoading ? [] : orders ? orders : [];
    setOrdersToList(ors);
    ors?.map((allOrs) => {
      if (allOrs.orderStatus !== "Delivered") {
        allOrs?.orderDetails?.map((or) => {
          if (orderDetails[or.foodItemId + "_" + or.itemName]) {
            orderDetails[or.foodItemId + "_" + or.itemName] += or.itemQuantity;
          } else {
            orderDetails[or.foodItemId + "_" + or.itemName] = or.itemQuantity;
          }
        });
      }
    });
    setOrderQuantity(orderDetails);
  }, [orders, orderRefetch, newOrders]);

  useEffect(() => {
    refetchFoodItems();
    let itemDetails = {};
    const items = isFoodItemsLoading ? [] : foodItems ? foodItems : [];
    items?.map((item) => {
      if (itemDetails[item._id + "_" + item.itemName]) {
        itemDetails[item._id + "_" + item.itemName] += item.itemQuantity;
      } else {
        itemDetails[item._id + "_" + item.itemName] = item.itemQuantity;
      }
    });
    setItemQuantity(itemDetails);
  }, [foodItems, refetchFoodItems, newOrders]);

  // useEffect(() => {
  //   const items = isLoading ? [] : orders ? orders : [];
  //   const foodIds = new Set(newOrders.map((f) => f?._id));
  //   const filterFd = items?.filter((it) => !foodIds.has(it?._id));
  //   if (items?.length > 0) setOrdersToList([...newOrders, ...filterFd]);
  //   else setOrdersToList([]);
  // }, [orders, newOrders, isLoading]);

  const handleShowAllOrders = () => {
    if (!orders) return;
    const nonDelivered = orders.filter(
      (order) =>
        order.orderStatus !== "Delivered" && order.orderType === "online"
    );
    setFilteredOrders(nonDelivered);
    setShowDelivered(false);
    setShowOutletOrders(false);
  };

  const handleShowOutletOrders = () => {
    setShowDelivered(false);
    setShowOutletOrders(true);
  };

  return (
    <>
      <ReUsableModal
        title="Update Order Status"
        payload={[
          {
            fieldName: "Order ID",
            fieldType: "text",
            fieldValue: displayOrderId,
            setMethod: setDisplayOrderId,
            disabled: true,
          },
          {
            fieldName: "Status",
            fieldType: "select",
            fieldValue: newStatus,
            setMethod: setNewStatus,
            options: [
              "Placed",
              "Confirmed",
              "Preparing",
              "Ready",
              "In_Delivery",
              "Delivered",
              "Delivery_Rejected",
              "Could_Not_Deliver",
              "Not_Placed",
              "Rejected",
            ],
          },
          ...(newStatus === "Delivered"
            ? [
                {
                  fieldName: "Delivery OTP",
                  fieldType: "text",
                  fieldValue: deliveryOtp,
                  setMethod: setDeliveryOtp,
                },
              ]
            : []),
        ]}
        show={showModal}
        submitDisabled={
          newStatus === "Delivered" && !/^\d{4}$/.test(deliveryOtp)
        }
        size="md"
        onHide={() => setShowModal(false)}
        onSubmit={handleOrderStatusUpdate}
        submit="Update"
        cancel="Cancel"
      />
      {/* <p style={{ color: "orange" }}>Available and Pending Orders Count</p> */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(3rem, 15rem))`, // Responsive columns
          gap: "0.1rem", // Adjust gap between cards
        }}
      >
        {Object.keys(itemQuantity).map((item) => (
          <>
            {(itemQuantity[item] > 0 || orderQuantity[item] > 0) && (
              <div
                key={item.id}
                style={{
                  borderRadius: "6px",
                  padding: "0px 0.01rem 0px 0.6rem",
                  margin: "0.01rem",
                  display: "inline-block", // Arrange cards horizontally
                  border: "solid 0.1px grey",
                  backgroundColor: "#eeeeee",
                }}
              >
                <h6
                  style={{
                    justifyContent: "left",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    color: "green",
                    margin: "auto",
                  }}
                >
                  {item.split("_")[1]}
                  {" : "}
                  <strong
                    style={{
                      fontSize: "0.9rem",
                      margin: "0 0.3rem",
                      color: "black",
                    }}
                  >
                    {" "}
                    {itemQuantity[item] > 0 ? itemQuantity[item] : 0}
                  </strong>

                  <strong
                    style={{
                      fontSize: "0.9rem",
                      margin: "0.03rem",
                      color: "orange",
                    }}
                  >
                    {orderQuantity[item] > 0 ? orderQuantity[item] : ""}
                  </strong>
                </h6>

                {/* <p
            style={{
              whiteSpace: "nowrap",
              color: "blue",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            Available:{" "}
            <strong style={{ fontSize: "1.1rem", margin: "0 0.3rem" }}>
              {" "}
              {item.availableQuantity}
            </strong>
          </p> */}
                {/* <p
            style={{
              whiteSpace: "nowrap",
              color: "green",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            In Order:{" "}
            <strong style={{ fontSize: "1.1rem", margin: "0 0.3rem" }}>
              {" "}
              {item.inOrderQuantity}{" "}
            </strong>
          </p> */}
              </div>
            )}
          </>
        ))}
      </div>
      <br />
      <Row
        style={{
          justifyContent: "left",
          alignItems: "center",
          margin: "auto",
          width: "95%",
        }}
      >
        <Button
          className="marginPointEight sixteenWidth buttonGreen numbersButton"
          onClick={handleShowAllOrders}
        >
          {" "}
          Open Orders :{" "}
          <strong>
            {
              ordersToList?.filter(
                (order) =>
                  order.orderStatus !== "Delivered" &&
                  order.orderType === "online"
              )?.length
            }
          </strong>
        </Button>
        <Button
          className="marginPointEight sixteenWidth buttonGreen numbersButton"
          onClick={handleShowDelivered}
        >
          {" "}
          Delivered Orders :{" "}
          <strong>
            {
              ordersToList?.filter((order) => order.orderStatus === "Delivered")
                ?.length
            }
          </strong>
        </Button>
        <Button
          className="marginPointEight sixteenWidth buttonGreen numbersButton"
          onClick={handleShowOutletOrders}
        >
          Outlet Orders:{" "}
          <strong>
            {
              ordersToList?.filter((order) => order.orderType === "outlet")
                ?.length
            }
          </strong>
        </Button>
        <Form.Control
          type="text"
          placeholder="Order ID or Mobile Number"
          value={searchText}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, ""); // Remove non-digits
            setSearchText(numericValue);
          }}
          style={{
            maxWidth: "20rem",
            marginLeft: "1rem",
            margin: "0.4rem",
          }}
        />
        {new Date(newOrders[0]?.createdAt).getTime() + 180 * 1000 >
          new Date().getTime() &&
          newOrders[0].orderType !== "outlet" && (
            <>
              <Button
                style={{
                  marginLeft: "1rem",
                  backgroundColor: "black",
                  fontSize: "0.7rem",
                  width: "15rem",
                }}
                className="marginPointEight numbersButton"
              >
                {newOrders?.map((ors) => (
                  <tr
                    className="twinkle-text"
                    style={{
                      color: "orange",
                      justifyContent: "center",
                    }}
                  >
                    <>
                      {ors.orderDetails?.map((item, index) => (
                        <span key={index}>
                          {item.itemName} - {item.itemQuantity}{" "}
                        </span>
                      ))}
                    </>
                  </tr>
                ))}
              </Button>
            </>
          )}
      </Row>
      <h6>
        {showDelivered
          ? "Delivered Orders"
          : showOutletOrders
          ? "OutletOrders"
          : "Open Orders"}
      </h6>

      <Row>
        <Col md={9}>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : orders ? (
            <div style={{ height: "100vh" }}>
              {searchText?.length > 0 && (
                <h6 style={{ color: "red" }}>you are seeing searched orders</h6>
              )}
              <div className="tableContainer">
                <Table
                  striped
                  bordered
                  hover
                  responsive="sm"
                  className="table-custom"
                >
                  <thead className={`${userInfo.themeColor}ThemeThead`}>
                    <tr>
                      <th>Order Id</th>
                      <th>Names</th>
                      <th>Count</th>
                      <th>Status</th>
                      <th>Delivery OTP</th>
                      <th>Amount</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody className={`${userInfo.themeColor}ThemeTbody`}>
                    {filteredOrders?.map((ors) => (
                      <tr key={ors._id}>
                        <td>
                          <a
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate("/orderDetails", {
                                state: { orderResponse: ors },
                              })
                            }
                          >
                            {ors.orderId}
                          </a>
                        </td>

                        <td>
                          {ors.orderDetails?.map((item, index) => (
                            <div key={index}>
                              {item.itemName} - {item.itemQuantity}
                            </div>
                          ))}
                        </td>
                        <td>
                          {ors.orderDetails.reduce(
                            (total, item) => total + Number(item.itemQuantity),
                            0
                          )}
                        </td>
                        <td>
                          <Form.Select
                            value={ors?.orderStatus}
                            onClick={() => {
                              setOrderId(ors?._id);
                              setDisplayOrderId(ors.orderId);
                              setNewStatus(ors?.orderStatus);
                              setDeliveryOtp(""); // reset OTP on open
                              setShowModal(true);
                            }}
                          >
                            <option value="Placed">Placed</option>
                            <option value="Confirmed">Confirmed</option>
                            <option value="Preparing">Preparing</option>
                            <option value="Ready">Ready</option>
                            <option value="In_Delivery">In_Delivery</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Delivery_Rejected">
                              Delivery_Rejected
                            </option>
                            <option value="Could_Not_Deliver">
                              Could_Not_Deliver
                            </option>
                            <option value="Not_Placed">Not_Placed</option>
                            <option value="Rejected">Rejected</option>
                          </Form.Select>
                        </td>
                        <td>{ors.deliveryOtp}</td>
                        <td>{ors.grossTotal}</td>
                        <td>
                          {new Date(
                            new Date(ors?.createdAt).getTime() +
                              5.5 * 60 * 60 * 1000
                          )
                            .toISOString()
                            .slice(11, 16)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Col>
        <Col md={3}>
          <div style={{ height: "100vh", fontSize: "1rem" }}>
            <div className="tableContainer">
              <Table
                striped
                bordered
                hover
                responsive="sm"
                className="table-custom"
              >
                <thead>
                  <tr>
                    <th style={{ color: "pink" }}> UnAvailable Items</th>
                  </tr>
                </thead>
                <tbody className={`${userInfo.themeColor}ThemeTbody`}>
                  {Object.keys(itemQuantity)?.map((ors) => (
                    <>
                      {itemQuantity[ors] < 1 && (
                        <tr>
                          <label style={{ color: "red" }}>
                            {" "}
                            {ors.split("_")[1]} - {itemQuantity[ors]}
                          </label>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default OrdersScreen;
